import { useTheme as useThemeBase } from 'styled-components';

import { Theme } from '../types';

const useTheme = () => useThemeBase() as Theme;

export default useTheme;
